import { EventEmitter } from "events"
export const CartEventBus = new EventEmitter()
export const CheckoutEventBus = new EventEmitter()
